// The intake form's text-message choice (Yes / No radios), turned into what
// the POST sends. Mirrors server/services/smsConsent.js intakeChoice: true is
// Yes, false is No, and a company that shows the radios answers 400 on field
// smsConsent when neither arrives.
//
// choice is the radio state: 'yes', 'no', or '' before the visitor picks one.

export const SMS_CHOICE_REQUIRED = 'Please choose whether we may text you service updates.';
export const SMS_PHONE_REQUIRED = 'Please enter a valid 10-digit phone number to receive text messages.';

// Same rule as the server (services/phoneE164.js): ten digits, or eleven
// starting with 1, area code and exchange starting 2-9.
export function isTextablePhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '').replace(/^1(?=\d{10}$)/, '');
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
}

// { error, field, smsConsent, smsChoiceShown }. error is null when the form
// may be sent; field says which control the error belongs to. smsConsent is
// false for a company that shows no radios, which is what an unticked box sent
// before. smsChoiceShown is true exactly when the radios were rendered: the
// server requires and records a choice only then, so the LawnTrack form and
// stale forms, which never send it, are asked nothing.
export function smsIntakeDecision(smsAvailable, choice, phone) {
  if (!smsAvailable) return { error: null, field: null, smsConsent: false, smsChoiceShown: false };
  if (choice !== 'yes' && choice !== 'no') {
    return { error: SMS_CHOICE_REQUIRED, field: 'smsConsent', smsConsent: undefined, smsChoiceShown: true };
  }
  if (choice === 'yes' && !isTextablePhone(phone)) {
    return { error: SMS_PHONE_REQUIRED, field: 'phone', smsConsent: true, smsChoiceShown: true };
  }
  return { error: null, field: null, smsConsent: choice === 'yes', smsChoiceShown: true };
}
